import { ReactNode } from 'react'
import { Box, Typography, Alert } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import { FpUserAccessKind, userCanAccessInspectorItem } from '../config/fpUserAccess'

interface FpUserGuardProps {
  kind: FpUserAccessKind
  id: string
  children: ReactNode
  fallback?: ReactNode
}

export default function FpUserGuard({ kind, id, children, fallback }: FpUserGuardProps) {
  const { user, isAuthenticated } = useAuth()

  if (!isAuthenticated || !user) return null

  if (userCanAccessInspectorItem(user.role, kind, id)) {
    return <>{children}</>
  }

  if (fallback) return <>{fallback}</>

  return (
    <Box sx={{ p: 3 }}>
      <Alert severity="warning">
        <Typography variant="h6" gutterBottom>
          🚫 Access Restricted
        </Typography>
        <Typography variant="body1">
          This area is not available to franchise partner users.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          Contact your administrator if you believe this is an error.
        </Typography>
      </Alert>
    </Box>
  )
}
